import React from "react";
import Field from "./Field";
import TextareaControl from "./TextareaControl";
import { TextareaFieldProps } from "./Types";

const TextareaField: React.FC<TextareaFieldProps> = ({ labelProps, controlProps, visible, disabled, cols, rows }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <TextareaControl {...controlProps} disabled={disabled} cols={cols} rows={rows} />
        </Field>
    );
}
export default TextareaField;